module.exports = __webpack_public_path__ + "static/media/deleteIcon.460b0152.svg";